import React from "react";
import MyImageSvg from "../../images/Icons/formula.svg";

function FormulaIcon({ width = 20, height = 20 }) {
  return (
    <span style={{ marginRight: "10px" }}>
      <img src={MyImageSvg} alt="forumla" width={width} height={height} />
    </span>
  );
}

export default FormulaIcon;
